import React, { useMemo } from "react";
import Skeleton from "../../../../components/skeleton";

/**
 * Skeleton loader for a chat thread item in the sidebar.
 * Optimized with useMemo for performance.
 * @returns {JSX.Element} The thread skeleton component.
 */
const ThreadSkeleton: React.FC = () => {
  return useMemo(() => <Skeleton className="h-10 w-full rounded-lg" />, []);
};

export default ThreadSkeleton;
